function firstNonEmptyString(...values) {
  return values.find((value) => typeof value === "string" && value.trim()) || "";
}

function toArray(data) {
  if (Array.isArray(data)) return data;
  return data?.results || data?.items || [];
}

function formatEventTypeLabel(eventType) {
  if (typeof eventType !== "string" || !eventType.trim()) return "图π通知";
  return eventType
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(" ");
}

function formatMoney(value) {
  if (value === undefined || value === null || value === "") return "";
  return `¥${value}`;
}

function buildNoticeFallback(notice) {
  const eventType = notice?.event_type || notice?.eventType || "";
  const payload = notice?.payload || {};
  const paymentNo = payload.payment_no || payload.paymentNo;
  const amount = formatMoney(payload.amount_yuan || payload.amountYuan || payload.refund_amount || payload.refundAmount);
  const failureCode = payload.failure_code || payload.failureCode;

  const fallbackMap = {
    ORDER_GRABBED: {
      title: "已有服务者接单",
      body: "你的快单已有服务者接单，订单已进入待确认阶段。",
    },
    ORDER_DELIVERED: {
      title: "服务者已提交交付",
      body: "服务者已提交交付，请尽快查看并验收。",
    },
    ORDER_ACCEPTED: {
      title: "交付已验收",
      body: "需求方已完成交付验收，订单已进入完成状态。",
    },
    ORDER_AUTO_ACCEPTED: {
      title: "订单已自动验收",
      body: "订单已到期自动验收，系统已继续处理后续结算。",
    },
    PAYMENT_CREATED: {
      title: "支付单已创建",
      body: paymentNo ? `支付单 ${paymentNo} 已创建，请尽快完成支付。` : "支付单已创建，请尽快完成支付。",
    },
    PAYMENT_SUCCEEDED: {
      title: "支付成功",
      body: paymentNo ? `支付单 ${paymentNo} 已支付成功，系统已开始为你匹配服务者。` : "订单支付已完成，系统已开始为你匹配服务者。",
    },
    PAYMENT_FAILED: {
      title: "支付失败",
      body: paymentNo ? `支付单 ${paymentNo} 未成功，你可以重新发起支付。` : "订单支付未成功，你可以重新发起支付。",
    },
    REFUND_REQUESTED: {
      title: "退款申请已提交",
      body: amount ? `退款申请已提交，本次退款金额为 ${amount}，系统正在处理中。` : "退款申请已提交，系统正在处理中。",
    },
    REFUND_SUCCEEDED: {
      title: "退款成功",
      body: amount ? `退款已处理完成，本次退款金额为 ${amount}。` : "退款已处理完成。",
    },
    SETTLEMENT_SUCCEEDED: {
      title: "结算成功",
      body: amount ? `订单结算已完成，本次结算金额为 ${amount}。` : "订单结算已完成。",
    },
    SETTLEMENT_HELD: {
      title: "结算暂未执行",
      body: failureCode ? `当前订单结算已被暂缓，原因代码为 ${failureCode}。` : "当前订单结算已被暂缓，请检查收款账户状态。",
    },
    SETTLEMENT_FAILED_FINAL: {
      title: "结算失败",
      body: failureCode ? `订单结算执行失败，失败代码为 ${failureCode}。` : "订单结算执行失败，请联系平台处理。",
    },
    PROVIDER_IDENTITY_VERIFIED: {
      title: "实名认证已通过",
      body: "你的实名认证已通过，可以继续进行服务者入驻流程。",
    },
    PROVIDER_IDENTITY_FAILED: {
      title: "实名认证未通过",
      body: failureCode ? `实名认证未通过，原因代码为 ${failureCode}，请核对资料后重新提交。` : "实名认证未通过，请核对资料后重新提交。",
    },
    PROVIDER_APPLICATION_APPROVED: {
      title: "服务者申请已通过",
      body: "你的服务者申请已通过审核，可以开始接单。",
    },
    PROVIDER_APPLICATION_REJECTED: {
      title: "服务者申请未通过",
      body: "你的服务者申请未通过审核，请根据原因补充资料后重新提交。",
    },
    PROVIDER_SUSPENDED: {
      title: "服务者资格已暂停",
      body: "你的服务者资格当前已被暂停，请联系平台了解处理进度。",
    },
    PROVIDER_RESUMED: {
      title: "服务者资格已恢复",
      body: "你的服务者资格已恢复，可以继续正常接单。",
    },
    ORDER_DISPUTE_OPENED: {
      title: "订单争议已发起",
      body: "订单已进入争议处理流程，请及时补充证据。",
    },
    ORDER_DISPUTE_RESOLVED: {
      title: "订单争议已处理完成",
      body: amount ? `订单争议已处理完成，本次退款金额为 ${amount}。` : "订单争议已处理完成。",
    },
  };

  return fallbackMap[eventType] || {
    title: formatEventTypeLabel(eventType) || "图π通知",
    body: eventType
      ? `你收到一条新的业务通知，事件类型为 ${eventType}。`
      : "你有一条新动态",
  };
}

export function getNoticeItems(data) {
  return toArray(data);
}

export function normalizeNotice(notice) {
  const payload = notice?.payload || {};
  const fallback = buildNoticeFallback(notice);
  return {
    id: notice?.id,
    title: firstNonEmptyString(
      notice?.title,
      payload.title,
      payload.message_title,
      payload.messageTitle,
      payload.actor_name,
      payload.sender_name,
      payload.username,
    ) || fallback.title,
    body: firstNonEmptyString(
      notice?.body,
      payload.body,
      payload.message,
      payload.text,
      payload.detail,
      payload.description,
    ) || fallback.body,
    action: notice?.action || null,
    readAt: notice?.read_at || notice?.readAt || null,
    createdAt: notice?.created_at || notice?.createdAt || notice?.delivered_at || notice?.deliveredAt || "",
    eventType: notice?.event_type || notice?.eventType || "",
  };
}
